@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-2 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-3 relative flex-wrap gap-2"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.12;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.08);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 6px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 8px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.18);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
          />
        </svg>
      </div>
      <div>
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          Vehicle Dashboard @if (selectedtenantNm) {
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ml-2"
            style="
              background: #f0fdfa;
              color: #0f766e;
              border: 1px solid #99f6e4;
            "
          >
            {{ selectedtenantNm }}
          </span>
          }
        </h1>
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Vehicle Tracking & Management
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center gap-2 flex-wrap">
      @if (filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Hide Filters
      </button>
      } @if (!filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Show Filters
      </button>
      } @if (vehicleListOpen) {
      <button
        (click)="toggleVehicleList()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #0f766e, #0d9488);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.3);
        "
      >
        <span nz-icon nzType="car" nzTheme="outline"></span>
        Hide Vehicles
      </button>
      } @if (!vehicleListOpen) {
      <button
        (click)="toggleVehicleList()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #0f766e, #0d9488);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.3);
        "
      >
        <span nz-icon nzType="car" nzTheme="outline"></span>
        Show Vehicles
      </button>
      }
    </div>
  </div>
</div>

<div class="vehDsbrd vehicle-slider-shell">
  <!-- Filter Section -->
  @if (filterPanelOpen) {
  <div class="widget-card" style="margin-bottom: 10px">
    <div
      class="row"
      style="display: flex; gap: 16px; margin: 0; flex-wrap: wrap"
    >
      <!-- ULB Dropdown -->
      @if (tntLst && tntLst.length > 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">Select {{ title }}</label>
        <nz-select
          class="slctBx"
          nzShowSearch
          nzPlaceHolder="Select {{ title }}"
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          @for (t of tntLst; track t) {
          <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst && tntLst.length == 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">{{ title }}</label>
        <div
          class="px-3 py-2 bg-gray-50 border border-gray-300 rounded text-gray-700 text-sm"
          style="height: 28px; line-height: 20px"
        >
          {{ tntLst[0].tnt_nm }}
        </div>
      </div>
      }
      <!-- Vendor Filter -->
      @if (ShowClap && vendorList && vendorList.length > 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">Vendor</label>
        <nz-select
          class="slctBx"
          nzShowSearch
          nzPlaceHolder="Select Vendor"
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      } @if (ShowClap && vendorList && vendorList.length == 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">Vendor</label>
        <div
          class="px-3 py-2 bg-gray-50 border border-gray-300 rounded text-gray-700 text-sm"
          style="height: 28px; line-height: 20px"
        >
          {{ vendorList[0].vndr_nm }}
        </div>
      </div>
      }
      <!-- Category Filter -->
      @if (vehCtgrys && vehCtgrys.length > 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">Category</label>
        <nz-select
          class="slctBx"
          nzShowSearch
          nzPlaceHolder="Select Category"
          [(ngModel)]="selectedCtgry"
          (ngModelChange)="selectCategory($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          @for (c of vehCtgrys; track c) {
          <nz-option
            [nzLabel]="c.asrt_ctgry_nm"
            [nzValue]="c.asrt_ctgry_id"
          ></nz-option>
          }
        </nz-select>
      </div>
      } @if (vehCtgrys && vehCtgrys.length == 1) {
      <div class="col-lg-3 col-md-4 col-sm-6">
        <label class="slctlbl">Category</label>
        <div
          class="px-3 py-2 bg-gray-50 border border-gray-300 rounded text-gray-700 text-sm"
          style="height: 28px; line-height: 20px"
        >
          {{ vehCtgrys[0].asrt_ctgry_nm }}
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Main Content Container -->
  <div class="main-content-wrapper" [class.sidebar-closed]="!vehicleListOpen">
    <!-- Left Content Area -->
    <div class="left-content-area">
      <!-- First Section: Vehicle Card/Info and Map -->
      <section class="widget-card">
        <div class="vehicle-map-grid-container">
          <!-- Left Part: Vehicle Card (Top) and Vehicle Info (Bottom) - 1/3 width -->
          <div class="vehicle-details-grid-column">
            <!-- Vehicle Card (Top) -->
            <div>
              <h2><span>Vehicle</span></h2>
              <div class="veList">
                @if (VhcleDetails?.crw_img_url && VhcleDetails?.crw_img_url !=
                'undefined') {
                <div class="driver-photo">
                  <img
                    [src]="$safeNavigationMigration(VhcleDetails?.crw_img_url)"
                    alt="Driver"
                  />
                </div>
                }
                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Registration Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value fw-600">
                    <h4 class="value-emphasis">
                      {{ vehnm == null ? "NA" : vehnm }}
                      @if (VhcleDetails?.asrt_ownr_id == 1) {
                      <span
                        style="
                          margin-left: 6px;
                          padding: 2px 8px;
                          font-size: 10px;
                          font-weight: 600;
                          border-radius: 4px;
                          background-color: #dbeafe;
                          color: #1d4ed8;
                        "
                        >Own Vehicle</span
                      >
                      } @if (VhcleDetails?.asrt_ownr_id == 2) {
                      <span
                        style="
                          margin-left: 6px;
                          padding: 2px 8px;
                          font-size: 10px;
                          font-weight: 600;
                          border-radius: 4px;
                          background-color: #fef3c7;
                          color: #b45309;
                        "
                        >Hired Vehicle</span
                      >
                      }
                    </h4>
                  </div>
                </div>

                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver Name</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    @if (VhcleDetails) {
                    <h4>
                      @if (VhcleDetails.crw_nm === null) {
                      <span>Driver not assigned</span>
                      } @if (VhcleDetails.crw_nm !== null) {
                      <span>
                        {{ VhcleDetails.crw_nm }}
                        @if (VhcleDetails.crw_own_in == 1) {
                        <span
                          style="
                            margin-left: 6px;
                            padding: 2px 8px;
                            font-size: 10px;
                            font-weight: 600;
                            border-radius: 4px;
                            background-color: #dbeafe;
                            color: #1d4ed8;
                          "
                          >Own Driver</span
                        >
                        } @if (VhcleDetails.crw_own_in == 2) {
                        <span
                          style="
                            margin-left: 6px;
                            padding: 2px 8px;
                            font-size: 10px;
                            font-weight: 600;
                            border-radius: 4px;
                            background-color: #fef3c7;
                            color: #b45309;
                          "
                          >Hired Driver</span
                        >
                        } @if (VhcleDetails.crw_own_in == 3) {
                        <span
                          style="
                            margin-left: 6px;
                            padding: 2px 8px;
                            font-size: 10px;
                            font-weight: 600;
                            border-radius: 4px;
                            background-color: #f3e8ff;
                            color: #7c3aed;
                          "
                          >APCOS Driver</span
                        >
                        }
                      </span>
                      }
                    </h4>
                    }
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver Phone Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    @if (VhcleDetails) {
                    <h4>
                      {{
                        VhcleDetails.crw_ph === null
                          ? "Driver not assigned"
                          : VhcleDetails.crw_ph
                      }}
                    </h4>
                    }
                  </div>
                </div>
                <div class="info-row current-location-row">
                  <div class="info-label">
                    <h3>Current Location</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value location-data-wrapper">
                    <span class="location-text">{{
                      VhcleDetails?.curr_loc || "NA"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Vehicle Info (Bottom) -->
            <div>
              <h2>
                <span>Vehicle Info</span
                ><span>&nbsp;({{ currentFrmtDate }})</span>
              </h2>
              <div class="veList">
                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Status</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ asrt_sts_nm == null ? "NA" : asrt_sts_nm }}</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Ignition</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      <span
                        class="ignition-badge"
                        [class.ignition-on]="ignitionStatus === 'ON'"
                        [class.ignition-off]="ignitionStatus === 'OFF'"
                      >
                        <span class="ignition-dot"></span>
                        {{ ignitionStatus }}
                      </span>
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Distance Travelled</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ CrntDyDst == null ? "0" : CrntDyDst }} Kms</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Start Location</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ VhcleDetails?.startFence || "NA" }}</h4>
                  </div>
                </div>

                @if (clntDtls && clntDtls[0].clnt_id==7) {
                <div class="info-row">
                  <div class="info-label">
                    <h3>Sachivalayam</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    @if (VhcleDetails) {
                    <h4>
                      {{
                        VhcleDetails.svm_nm == null
                          ? "Sachivalayam not assigned"
                          : VhcleDetails.svm_nm
                      }}
                    </h4>
                    }
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Secratory</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    @if (VhcleDetails) {
                    <h4>
                      {{
                        VhcleDetails.ss_nm == null
                          ? "Secratory not assigned"
                          : VhcleDetails.ss_nm
                      }}
                      @if (VhcleDetails.ss_cntct) {
                      <span>
                        -
                        {{
                          VhcleDetails.ss_cntct == null
                            ? ""
                            : VhcleDetails.ss_cntct
                        }}</span
                      >
                      }
                    </h4>
                    }
                  </div>
                </div>
                }

                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Odometer Reading</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ vehOdmtr == null ? 0 : vehOdmtr }} km</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Device Odometer Reading</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ devOdmtr == null ? 0 : devOdmtr }} km</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>IMEI Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ imei == null ? "" : imei }}</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Chasis Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ chasis == null ? "Not provided" : chasis }}</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Speed</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ speed == null ? 0 : speed }} km/Hr</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Coverage%</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        $safeNavigationMigration(VhcleDetails?.coverage_per) ===
                        null
                          ? 0
                          : VhcleDetails?.coverage_per
                      }}
                      %
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Departure Time</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        $safeNavigationMigration(
                          VhcleDetails?.hme_fnce_out_ts
                        ) === null
                          ? "NA"
                          : VhcleDetails?.hme_fnce_out_ts
                      }}
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Data Last Received on</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ data_lst_rcvd == null ? "" : data_lst_rcvd }}</h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Stoppages</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4
                      class="link-value"
                      [ngClass]="{
                        hgltCls:
                          $safeNavigationMigration(
                            VhcleDetails?.stps_morethn_five
                          ) > 0
                      }"
                      (click)="showStoppages()"
                    >
                      {{
                        $safeNavigationMigration(
                          VhcleDetails?.stps_morethn_five
                        ) === null
                          ? "0"
                          : VhcleDetails?.stps_morethn_five
                      }}
                    </h4>
                  </div>
                </div>
                @if (vehRts && vehRts.length>0 && vehRts[0].frnt_cmra_url) {
                <div class="info-row camera-row">
                  <div class="info-label">
                    <h3>Front Camera</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <a
                      target="_blank"
                      [href]="vehRts[0].frnt_cmra_url"
                      class="camera-link"
                    >
                      <i
                        nz-icon
                        nzType="camera"
                        nzTheme="outline"
                        class="icnHvr"
                      ></i>
                      <span>Open Feed</span>
                    </a>
                  </div>
                </div>
                } @if (vehRts && vehRts.length>0 && vehRts[0].bck_cmra_url) {
                <div class="info-row camera-row">
                  <div class="info-label">
                    <h3>Rear Camera</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <a
                      target="_blank"
                      [href]="vehRts[0].bck_cmra_url"
                      class="camera-link"
                    >
                      <i
                        nz-icon
                        nzType="camera"
                        nzTheme="outline"
                        class="icnHvr"
                      >
                      </i>
                      <span>Open Feed</span>
                    </a>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>

          <!-- Map Column (Right Part) - 2/3 width -->
          <div class="map-grid-column">
            <div class="row" style="margin: 0">
              <div class="col-lg-12 col-md-12">
                <div class="row" style="margin-bottom: 10px">
                  <label
                    nz-checkbox
                    [(ngModel)]="shwCrntLoc"
                    (ngModelChange)="onChkCurrentLocation($event)"
                    >Current Location</label
                  >
                  <label
                    nz-checkbox
                    [(ngModel)]="shwplyback"
                    (ngModelChange)="onChkPlyback($event)"
                    >Playback</label
                  >
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                @if (!shwCrntLoc) {
                <div>
                  <div class="mapdslctnDtls">
                    <div class="travelruts">
                      <div class="grenbx"></div>
                      <div class="redbxlbl">Schedule Route</div>
                    </div>
                    <div class="scheduleruts">
                      <div class="redbx"></div>
                      <div class="redbxlbl">Travelled Route</div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            <div id="vehicleMap"></div>
          </div>
        </div>
      </section>

      <!-- Heatmap Chart Section -->
      <section class="widget-card">
        <div class="row bg-w chart-card">
          <div class="col-lg-12 col-md-12 crd">
            <h1>Last 7days 24/7 Distance covered by vehicle</h1>
            <div id="hepachartdiv"></div>
          </div>
        </div>
      </section>

      <!-- Charts Section: Two graphs in a row -->
      <section class="widget-card">
        <div class="row" style="display: flex; gap: 20px; margin: 0">
          <div
            class="col-lg-6 col-md-6 col-sm-12 crd"
            style="flex: 1; min-width: 0"
          >
            <h1>Last 7Days Distance Travelled</h1>
            <div>
              @if (!chart1Msg) {
              <div id="lastSevenDaysDistanceChart"></div>
              } @if (chart1Msg) {
              <div class="row NtfctnCrd">
                <h5 style="text-align: center">{{ chart1Msg }}</h5>
              </div>
              }
            </div>
          </div>
          <div
            class="col-lg-6 col-md-6 col-sm-12 crd"
            style="flex: 1; min-width: 0"
          >
            <h1>Last 7Days Trips Travelled</h1>
            <div>
              @if (!chart2Msg) {
              <div id="lastSevenDaysChart"></div>
              } @if (chart2Msg) {
              <div class="row NtfctnCrd">
                <h5 style="text-align: center">{{ chart2Msg }}</h5>
              </div>
              }
            </div>
          </div>
        </div>
      </section>

      <!-- Fuel Chart Section -->
      <section class="widget-card">
        <div class="row" style="display: flex; gap: 20px; margin: 0">
          <div
            class="col-lg-6 col-md-6 col-sm-12 crd"
            style="flex: 1; min-width: 0"
          >
            <h1>Fuel Consumption (7 Days)</h1>
            <div>
              @if (!fuelChartMsg) {
              <div id="fuelChartDiv" style="height: 320px"></div>
              } @if (fuelChartMsg) {
              <div class="row NtfctnCrd">
                <h5 style="text-align: center">{{ fuelChartMsg }}</h5>
              </div>
              }
            </div>
          </div>
          <div
            class="col-lg-6 col-md-6 col-sm-12 crd bxshw_n"
            style="flex: 1; min-width: 0"
          >
            <h1>Operational Details In Last 7Days</h1>
            @if (oprtnlhrs && oprtnlhrs.length>0) {
            <div class="cstm_tbl-wrapper">
              <table class="cstm_tbl">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Vehicle No.</th>
                    <th>Vehicle Category</th>
                    <th>Operational Hours</th>
                    <th>Travelled(km)</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  @for (o of oprtnlhrs; track o) {
                  <tr>
                    <td>{{ o.dt }}</td>
                    <td>{{ o.asrt_nm }}</td>
                    <td>{{ o.asrt_ctgry_nm }}</td>
                    <td>{{ o.oprtn_hrs_ct }}</td>
                    <td>{{ o.dst }}</td>
                    @if (o.operated == 1) {
                    <td style="color: #009688">Operated</td>
                    } @if (o.operated == 0) {
                    <td style="color: #9c27b0">Not-Operated</td>
                    }
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            } @if (oprtnlhrsMsg) {
            <div class="row NtfctnCrd">
              <h5 style="text-align: center">{{ oprtnlhrsMsg }}</h5>
            </div>
            }
          </div>
        </div>
      </section>

      <!-- Tables Section: Two tables in a row -->
      <section class="widget-card" style="border-top: 2px solid #f1f1f1">
        <div class="row" style="display: flex; gap: 20px; margin: 0">
          <div
            class="col-lg-6 col-md-6 col-sm-12 w-50 crd bxshw_n"
            style="flex: 1; min-width: 0"
          >
            <h1>
              Last 7Days Trips List @if (eachVeh && eachVeh.length) {
              <b>{{ VhcleDetails?.asrt_nm }}</b>
              }
            </h1>
            @if (eachVeh && eachVeh.length>0) {
            <div class="cstm_tbl-wrapper">
              <table class="cstm_tbl">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>No. of Trips</th>
                    <th>Driver</th>
                    <th>Travelled(km)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (o of eachVeh; track o) {
                  <tr>
                    <td>{{ o.dt }}-{{ curYr }}</td>
                    <td>{{ o.trp_cnt }}</td>
                    <td>{{ o.crw_nm ? o.crw_nm : "Driver not Assigned" }}</td>
                    <td>{{ o.trp_dst }}</td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            } @if (tripsMsg) {
            <div class="row NtfctnCrd">
              <h5 style="text-align: center">{{ tripsMsg }}</h5>
            </div>
            }
          </div>
          <div
            class="col-lg-6 col-md-6 col-sm-12 w-50 crd bxshw_n"
            style="flex: 1; min-width: 0"
          >
            <h1>Last 7Days Speed Violation</h1>
            @if (ovrSpeed && ovrSpeed.length>0) {
            <div class="row">
              <div class="cstm_tbl-wrapper">
                <table class="cstm_tbl">
                  <thead>
                    <tr>
                      <th>Recorded Date</th>
                      <th>Vehicle No.</th>
                      <th>Vehicle Category</th>
                      <th>Speed(km)</th>
                      <th>Track Vehicle</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (t of ovrSpeed; track t) {
                    <tr>
                      <td>{{ t.dt }}</td>
                      <td>{{ t.asrt_nm }}</td>
                      <td>{{ t.asrt_ctgry_nm }}</td>
                      <td>{{ t.speed }}</td>
                      <td>
                        <a
                          href="https://www.google.com/maps/search/?api=1&query={{
                            t.f_lat
                          }},{{ t.f_lng }}"
                          target="_blank"
                          ><i nz-icon nzType="node-index" nzTheme="outline"></i
                          >Track</a
                        >
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            } @if (ovrSpeedMsg) {
            <div class="row NtfctnCrd">
              <h5 style="text-align: center">{{ ovrSpeedMsg }}</h5>
            </div>
            }
          </div>
        </div>
      </section>
    </div>

    <!-- Right Sidebar - Vehicle List (Heatmap Style) -->
    @if (vehicleListOpen) {
    <div class="vehicles-panel">
      <div class="panel-header">
        <div class="panel-title">
          <i nz-icon nzType="car" nzTheme="outline"></i>
          <span>Vehicles</span>
          @if (ttl_veh && ttl_veh.length) {
          <span class="vehicle-count">{{ ttl_veh.length }}</span>
          }
        </div>
        <div class="header-actions">
          <!-- Auto-refresh toggle with countdown -->
          <button
            class="refresh-btn"
            [class.active]="autoRefreshEnabled"
            (click)="toggleAutoRefresh()"
            nz-tooltip
            [nzTooltipTitle]="
              autoRefreshEnabled
                ? 'Auto-refresh ON (every 30s)'
                : 'Auto-refresh OFF'
            "
          >
            <i
              nz-icon
              nzType="sync"
              nzTheme="outline"
              [class.spinning]="autoRefreshEnabled"
            ></i>
            @if (autoRefreshEnabled) {
            <span class="countdown">{{ refreshCountdown }}</span>
            }
          </button>
          <!-- Manual refresh button -->
          <button
            class="refresh-btn manual"
            (click)="manualRefresh()"
            nz-tooltip
            nzTooltipTitle="Refresh now"
          >
            <i nz-icon nzType="reload" nzTheme="outline"></i>
          </button>
          <button class="close-btn" (click)="toggleVehicleList()">
            <i nz-icon nzType="close" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div class="search-box">
        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Search vehicles..."
          [ngModelOptions]="{ standalone: true }"
          class="search-input"
        />
      </div>
      <div class="vehicles-list">
        @for (item of ttl_veh | filterasrt:searchText; track item) {
        <button
          class="vehicle-card-v2"
          [class.running]="item.live_status === 'Running'"
          [class.parked]="item.live_status === 'Parked'"
          [class.idle]="item.live_status === 'Idle'"
          [class.offline]="item.live_status === 'Offline'"
          [class.selected]="item.apply_actv == 1"
          (click)="selectVehicle(item)"
        >
          <div class="card-top-row">
            <img
              [src]="getVehicleIconPath(item)"
              class="vehicle-icon"
              onerror="this.src='assets/images/markers/mapIcons/truck_p.png'"
            />
            <div class="vehicle-info">
              <span class="vehicle-name">{{ item.asrt_nm }}</span>
              @if (item.asrt_ctgry_nm) {
              <span class="vehicle-category">{{ item.asrt_ctgry_nm }}</span>
              }
            </div>
          </div>
          <div class="card-status-row">
            <!-- Live Status (Running/Parked/Offline) - Only show when vehicle is Online/Active -->
            @if (item.asrt_sts_nm === 'Online' || item.asrt_sts_nm === 'Active'
            || item.asrt_sts_nm === 'Offline' || item.asrt_sts_nm ===
            'Inactive') {
            <div
              class="status-item live-status"
              [class.running]="item.live_status === 'Running'"
              [class.parked]="item.live_status === 'Parked'"
              [class.idle]="item.live_status === 'Idle'"
              [class.offline]="item.live_status === 'Offline'"
            >
              <span class="status-dot"></span>
              <span class="status-text">
                {{
                  item.live_status === "Running"
                    ? item.speed_ct > 0
                      ? item.speed_ct + " km/h"
                      : "Running"
                    : item.live_status
                }}
              </span>
            </div>
            }
            <!-- Vehicle Status from Vehicle Info -->
            <div
              class="status-item vehicle-status"
              [class.online]="
                item.asrt_sts_nm === 'Online' || item.asrt_sts_nm === 'Active'
              "
              [class.offline]="
                item.asrt_sts_nm === 'Offline' ||
                item.asrt_sts_nm === 'Inactive'
              "
              [class.repair]="
                item.asrt_sts_nm === 'Repair' ||
                item.asrt_sts_nm === 'Under Repair' ||
                item.asrt_sts_nm === 'Maintenance' ||
                item.asrt_sts_nm === 'Service'
              "
            >
              <i
                nz-icon
                [nzType]="
                  item.asrt_sts_nm === 'Repair' ||
                  item.asrt_sts_nm === 'Under Repair' ||
                  item.asrt_sts_nm === 'Maintenance' ||
                  item.asrt_sts_nm === 'Service'
                    ? 'tool'
                    : item.asrt_sts_nm === 'Online' ||
                      item.asrt_sts_nm === 'Active'
                    ? 'check-circle'
                    : 'info-circle'
                "
                nzTheme="outline"
              ></i>
              <span class="status-text">{{
                item.asrt_sts_nm || "Unknown"
              }}</span>
            </div>
          </div>
        </button>
        } @if (!ttl_veh || ttl_veh.length === 0) {
        <div class="empty-state">
          <i nz-icon nzType="car" nzTheme="outline" class="empty-icon"></i>
          <p class="empty-text">No vehicles found</p>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>

<!-- Stoppages Modal -->
<nz-modal
  [(nzVisible)]="shwStpgWndw"
  nzTitle="Stoppage Details"
  (nzOnCancel)="closeStpgSideBar()"
  (nzOnOk)="handleOk()"
  [nzWidth]="drawerWidth"
  nzClassName="prkngdtls"
>
  <ng-container *nzModalContent>
    <app-data-grid
      id="grid"
      class="gridHeight"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="stpgData"
      [legacyColumns]="stpgcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="Parking points List"
      [pageSize]="10"
      [allowedPageSizes]="[10, 30, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="false"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons_edit"
        [width]="100"
        caption="Location"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="cursor-pointer tblEdtBtn" (click)="vewonMap(data.data)">
            Map View
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </ng-container>
</nz-modal>
